/**
 * Welcome (docs/11 §3.1, amended): the door. Nothing about tonight's events
 * is shown until the driver is signed in — the owner's call, and it keeps
 * the product entirely behind an account. Just the promise and two ways in.
 */
import { Zap, Clock, MapPin, CarFront } from 'lucide-react';
import { Button } from './ui.js';

export function WelcomeScreen({ onGetStarted, onSignIn }: { onGetStarted: () => void; onSignIn: () => void }) {
  return (
    <div className="welcome">
      <span className="brand"><span className="mark"><Zap size={18} aria-hidden="true" /></span>Surge</span>
      <h1 className="tagline">Know where the crowd comes out — before it does.</h1>

      <section className="card" aria-label="What Surge does" style={{ gap: 14 }}>
        <div className="meta">
          <span className="pair wrap"><Clock size={20} aria-hidden="true" /><span className="wrap">Tonight’s exits in time order, with a leave-by time for each one.</span></span>
        </div>
        <div className="meta">
          <span className="pair wrap"><MapPin size={20} aria-hidden="true" /><span className="wrap">The legal pickup curb for your vehicle, not the venue’s front door.</span></span>
        </div>
        <div className="meta">
          <span className="pair wrap"><CarFront size={20} aria-hidden="true" /><span className="wrap">How many other Surge drivers are already heading there.</span></span>
        </div>
      </section>

      <p className="promise">For taxi and rideshare drivers in Rhode Island and Massachusetts.</p>

      <Button variant="primary" onClick={onGetStarted}>Get started</Button>
      <Button variant="secondary" onClick={onSignIn}>I have an account</Button>

      <p className="foot">Free while in testing</p>
    </div>
  );
}
